import React from "react";

import './header.styles.scss';

const Header = () => {
  return (
    <div className='header'>
      <h1 className='center'>Kwan Yoon</h1>
      <hr />
      <h3 className='center'>2B Computer Science | University of Waterloo</h3>
    </div>
  );
}

export default Header;
